import React from "react";
import { connect } from "react-redux";
import { t } from "ttag";

import { IFormUUID } from "../../../models/nominals";
import { TStateMapper } from "../../reducers.interfaces";
import { WriteReviewFormMode } from "../constants";
import { getWriteReviewFormMode } from "../selectors";

interface IOwnProps {
    formUUID: IFormUUID;
}

interface IReduxProps {
    isOpen: boolean;
}

interface IProps extends IOwnProps, IReduxProps {}

interface IState {}

// TODO(ssr, LEVEL 2 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 2/10 due to 66 LOC, simple conditional rendering, Redux integration, and no complex state or lifecycle methods.
class WriteReviewThankYouComponent extends React.PureComponent<IProps, IState> {
    render() {
        if (!this.props.isOpen) {
            return null;
        }
        return (
            <div className="review-thank-you" role="alert">
                <h2 className="review-thank-you__title">
                    {t`Thank You for Writing a Review`}
                </h2>
                <p>
                    {t`We appreciate your feedback and comments, and always enjoy hearing from you.`}
                </p>
                <p>
                    {t`Return to the `}
                    <a
                        title={t`Home`}
                        href="/"
                        className="review-thank-you__home"
                        target="_self"
                    >
                        {t`homepage`}
                    </a>
                    <span>.</span>
                </p>
            </div>
        );
    }
}

const mapStateToProps: TStateMapper<"reviews", IReduxProps, IOwnProps> = (
    rootState,
    ownProps,
) => {
    const displayMode = getWriteReviewFormMode(rootState.reviews, ownProps);
    return {
        ...ownProps,
        isOpen: displayMode === WriteReviewFormMode.THANK_YOU_OPEN,
    };
};

export const WriteReviewThankYou = connect(mapStateToProps)(
    WriteReviewThankYouComponent,
);
